module.exports = __webpack_public_path__ + "img/personal22.7bcfd828.jpeg";